/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Good_Bad_Crab_EngageInputs */

const fr_good_bad_crab_engage = /** @type {(inputs: Good_Bad_Crab_EngageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer Score`)
};

/**

* @param {Good_Bad_Crab_EngageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const good_bad_crab_engage = /** @type {((inputs?: Good_Bad_Crab_EngageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Good_Bad_Crab_EngageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_good_bad_crab_engage(inputs)
});